module.exports = __webpack_public_path__ + "static/media/ZEE-BNB.1556795c.svg";